const gravityForm = gform; /* eslint-disable-line no-undef */

$(document).ready(function() {
  
  checkIfPreferSpecialist();
  
  dynamicReverseReferralForm();

  setTimeout(function() {
    ajax_populate_hidden_fields();
  }, 3000);

});

// Reverse Referral Form
// target gravity forms ID
// detect whether conditional fields
// are hidden or show
function checkIfPreferSpecialist() {

  // eslint-disable-next-line no-unused-vars
  gravityForm.addAction('gform_post_conditional_logic_field_action', function (formId, action, targetId, defaultValues, isInit) {

    let LoId = localStorage.getItem('loid');

    if (formId == 13 || formId == 27) {
  
        jQuery.ajax({
          type: 'POST',
          url: '/wp-admin/admin-ajax.php',
          data: {
            action: 'populate_form_fields',
            loid: LoId,
          },
          success: function (output) {

            let loanOfficerFirstName = output['data']['loan_officer_first_name'];
            let loanOfficerLastName = output['data']['loan_officer_last_name'];
            let loanOfficerEmail = output['data']['loan_officer_email'];

            // LO First Name
            $('.specialist-first-name .ginput_container input').val(loanOfficerFirstName);

            // LO Last Name
            $('.specialist-last-name .ginput_container input').val(loanOfficerLastName);

            // LO Email
            $('.specialist-email .ginput_container input').val(loanOfficerEmail);
          
          },
        }); 

        $('.specialist-first-name .ginput_container input').val($('.specialist-first-name .ginput_container input').val());

        $('.specialist-last-name .ginput_container input').val($('.specialist-last-name .ginput_container input').val());

        $('.specialist-email .ginput_container input').val($('.specialist-email .ginput_container input').val());

    }

  });

}  

function ajax_populate_hidden_fields() {
  let LoId = localStorage.getItem('loid');
  let UTMUrl = localStorage.getItem('utm_url');

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);  

  let utm_source = urlParams.get('utm_source');
  let utm_medium = urlParams.get('utm_medium');
  let utm_campaign = urlParams.get('utm_campaign');
  let utm_content = urlParams.get('utm_content');
  let utm_term = urlParams.get('utm_term');

  jQuery.ajax({
    type: 'POST',
    url: '/wp-admin/admin-ajax.php',
    data: {
      action: 'populate_form_fields',
      loid: LoId,
    },
    success: function (output) {

      console.log(output);

        // Sales Engine ID
        $('.gform_hidden.sales_engine_id input.gform_hidden').val(output['data']['sales_engine_id']);

        // Premiere Group Flag
        $('.gform_hidden.premier_group_flag input.gform_hidden').val(output['data']['premier_group_flag']);

        // LO ID
        $('.gform_hidden.loid input.gform_hidden').val(output['data']['loan_officer_id']);

        // UTM URL
        $('.gform_hidden.utm_url input.gform_hidden').val(UTMUrl);

        // UTM Source
        $('.gform_hidden.utm_source input.gform_hidden').val(utm_source);
        
        // UTM Medium
        $('.gform_hidden.utm_medium input.gform_hidden').val(utm_medium);
        
        // UTM Campaign
        $('.gform_hidden.utm_campaign input.gform_hidden').val(utm_campaign);
        
        // UTM Content
        $('.gform_hidden.utm_content input.gform_hidden').val(utm_content);      
        
        // UTM Term
        $('.gform_hidden.utm_term input.gform_hidden').val(utm_term);          

        // LO NMLS
        $('.gform_hidden.nmlsid input.gform_hidden').val(output['data']['loan_officer_nmls']);

        // LO First Name
        $('.specialist-first-name .ginput_container input').val(output['data']['loan_officer_first_name']);

        // LO Last Name
        $('.specialist-last-name .ginput_container input').val(output['data']['loan_officer_last_name']);

        // LO Email
        $('.specialist-email .ginput_container input').val(output['data']['loan_officer_email']);  
     
    },
  });
}

// Reverse Referral form
function dynamicReverseReferralForm() {

  $('.reverse-referral-form .loan-officer-first-name input, .reverse-referral-form .loan-officer-last-name input').change(function() {

  let loanOfficerFirstName = $('.reverse-referral-form .loan-officer-first-name input').val();
  let loanOfficerLastName = $('.reverse-referral-form .loan-officer-last-name input').val();
  let loanOfficerFullName = loanOfficerFirstName + ' ' + loanOfficerLastName;

  $('.reverse-referral-form .referring_loan_officer input').val(loanOfficerFullName);

  });

}



// WEBPACK FOOTER //
// ./scripts/form-updater.js